









import ECharts from 'vue-echarts'
import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {DeletePatPna, GetPatPnas, GetPdWeightStatistics} from "@/api/hd"

@Component({
	components: {ECharts}
})
export default class XX extends AbpBase {
	@Prop() patient: any
	addOrEditShow = false
	addOrEditData: any = {}
	loading = false
	tableData = []
	echartsData: any = {}

	mounted() {
		this.clearEchart()
		this.init()
	}

	columns = [
		{
			title: '透析日期',
			key: 'dialysisDate',
			// render: (h: any, params: any) => {
			// 	return h('span', this.formatDate(params.row.dialysisDate))
			// }
		}, {
			title: '干体重',
			key: 'dryWeight'
		},{
			title: '透前体重',
			key: 'beforeWeight'
		}, {
			title: '透前BMI',
			key: 'beforeBMI'
		},{
			title: '透后体重',
			key: 'afterWeight'
		},{
			title: '透后BMI',
			key: 'afterBMI'
		},
	]

	download() {


		(this.$refs.table as any).exportCsv({
			filename: `${this.formatDate(new Date())} ${this.patient.patientName}透析体重统计`
		})
	}

	private async init() {
		let res = await GetPdWeightStatistics({patientId: this.patient.id})

		this.clearEchart()
		res.objects.forEach((item: any) => {
			item.dialysisDate = this.formatDate(item.dialysisDate)
			//X轴点 透析日期
			this.echartsData.xAxis.data.push(this.formatDate(item.dialysisDate))
			this.echartsData.series[0].data.push(item.dryWeight)
			this.echartsData.series[1].data.push(item.beforeWeight)
			this.echartsData.series[2].data.push(item.beforeBMI)
			this.echartsData.series[3].data.push(item.afterWeight)
			this.echartsData.series[4].data.push(item.afterBMI)
		})
		this.tableData = res.objects
	}


	private clearEchart() {
		this.echartsData = {
			title: {
				text: '透析体重统计'
			},
			tooltip: {
				trigger: 'axis'
			},
			legend: {
				data:['干体重','透前体重','透前BMI','透后体重','透后BMI']
			},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			toolbox: {
				feature: {
					saveAsImage: {}
				}
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				data: []  //X轴坐标点  需遍历按日期添加
			},
			yAxis: {
				type: 'value'
			},
			series: [
				{
					name:'干体重',
					type:'line',
					stack: '总量',
					data:[]
				},
				{
					name:'透前体重',
					type:'line',
					stack: '总量',
					data:[]
				},
				{
					name:'透前BMI',
					type:'line',
					stack: '总量',
					data:[]
				},
				{
					name:'透后体重',
					type:'line',
					stack: '总量',
					data:[]
				},
				{
					name:'透后BMI',
					type:'line',
					stack: '总量',
					data:[]
				}
			]
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/treatmentAnalysis/weight.vue